import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '1',
    text: 'Descarga la guía en PDF con 60 páginas prácticas'
  }, {
    num: '2',
    text: 'Aplica los prompts en las áreas clave: productividad, negocio, vida personal'
  }, {
    num: '3',
    text: 'Personaliza cada solución con ejemplos y casos reales'
  }];
  return <section className="py-24 px-6 bg-gradient-to-b from-navy-800 to-navy-900 relative" data-id="element-105">
      <div className="max-w-5xl mx-auto" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-107">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-108">
            Cómo funciona
          </h2>
          <div className="w-24 h-1 bg-cyan-neon mx-auto rounded-full" data-id="element-109"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-110">
          {/* Connecting Line (Desktop only) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-[2px] bg-gradient-to-r from-cyan-neon/10 via-cyan-neon/40 to-cyan-neon/10 z-0" data-id="element-111"></div>

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="relative z-10 flex flex-col items-center text-center group" data-id="element-112">
              <div className="w-24 h-24 rounded-full bg-navy-800 border-2 border-cyan-neon shadow-[0_0_20px_rgba(0,242,255,0.2)] flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-113">
                <span className="text-4xl font-black text-cyan-neon drop-shadow-[0_0_10px_rgba(0,242,255,0.8)]" data-id="element-114">
                  {step.num}
                </span>
              </div>
              <p className="text-lg text-slate-300 font-medium px-4" data-id="element-115">
                {step.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}